import React, { useEffect, useState } from "react";
import useListarLineas from "../../../queries/plan/useListarLineas";
import { useUsuario } from "../../../context/usuarioContext";
import CustomTable from "@sistemas.mundo/custom-table";
import { Box, Tooltip } from "@mui/material";
import StarIcon from "@mui/icons-material/Star";
import CircleIcon from "@mui/icons-material/Circle";

const ListLineas = ({recordatorioLineas}) => {
  const { contratoSeleccionado } = useUsuario();
  const [refetchData, setRefetchData] = useState(null);

  const estadosContratos = [
    "Borrador",
    "Firmado",
    "Pendiente Comercial",
    "Pdte Regularizar",
    "Confirmación",
    "Pdte PEX / Diseño",
    "Pdte Envío SIM",
    "Pdte Retiro SIM",
    "Conectado",
    "Pendiente Portabilidad",
    "Baja",
    "Cobrado",
  ];

  const tableRows = [
    {
      name: "linea",
      type: "",

      draw: (data) =>
        data.principal ? (
          <Tooltip title="Principal">
            <div style={{ display: "flex", alignItems: "center" }}>
              {data.lineaFull}
              <Box pl={2} />
              <StarIcon color="primary" />
            </div>
          </Tooltip>
        ) : (
          data.lineaFull
        ),
    },
    {
      name: "linea",
      type: "",
      draw: (data) => {
        return (
          <>
            <Tooltip title={estadosContratos[data.cont_estado - 1]}>
              <div style={{ display: "flex", alignItems: "center" }}>
                {estadosContratos[data.cont_estado - 1]}
                <CircleIcon
                  color={
                    data.cont_estado == 9
                      ? "success"
                      : data.cont_estado != 11
                      ? "primary"
                      : "disabled"
                  }
                />
              </div>
            </Tooltip>
          </>
        );
      },
    },
    {
      name: "linea",
      type: "",
      draw: (data) => {
        if (data.tico_id == 5) {
          return "Cambio de número";
        }
        if (data.tipo_linea == 0) {
          return "Móvil";
        } else if (data.tipo_linea == 1) {
          return "VOIP";
        } else {
          return "";
        }
      },
    },

    {
      name: "linea",
      type: "",
      draw: (data) => {
        if(data.solicitud_portabilidad){
          return data.solicitud_portabilidad.modalidad == 0 ? "Prepago" : "Postpago"

        }

        return ""
     
      },
    },
  ];

  const tableHeaders = [
    { name: "Número", type: "" },
    { name: "Estado", type: "" },
    { name: "Tipo de línea", type: "" },
    { name: "Modalidad", type: "" },
  ];

  useEffect(() => {
    if (contratoSeleccionado) {
      setRefetchData(Math.random());
    }
  }, [contratoSeleccionado]);

  return (
    <CustomTable
      queryData={useListarLineas}
      tableRows={tableRows}
      tableHeaders={tableHeaders}
      refetchData={refetchData}
      tableId="tabla_lineas"
      camposFilter={[
        {
          elements: [
            {
              name: "contrato_id",
              type: "text",
              value: contratoSeleccionado.contrato_id_padre ?? contratoSeleccionado.id_contrato,
            },
          ],
        },
      ]}
    />
  );
};

export default ListLineas;
